module.exports = __webpack_public_path__ + "img/jej3.3b46bbda.png";